module.exports = __webpack_public_path__ + "img/C05TechHerbalMedicine_ua.ef155849.webp";